// @ts-nocheck
import React from 'react';
import { BoxV2 } from 'sonata-react-components';

import { SummaryCampaignItemDetailsFilters } from './SummaryCampaignItemDetailsFilters';
import { SummaryCampaignItemDetailsTable } from './SummaryCampaignItemDetailsTable';
import './summaryCampaignItemDetails.scss';

import type { FilterSection } from '@/ts-types/reporting.types';

type Props = {
  filterSection: FilterSection;
};

export function SummaryCampaignItemDetails({ filterSection }: Props): React.ReactElement {
  return (
    <BoxV2 id="reportingCampaignItemDetails-box">
      <BoxV2.Body bgColor="background01" className="reportingCampaignItemDetailsContainer" padding="24px">
        <SummaryCampaignItemDetailsFilters />
        <SummaryCampaignItemDetailsTable filterSection={filterSection} />
      </BoxV2.Body>
    </BoxV2>
  );
}
